import React, { Component } from "react";
import { connect } from 'react-redux'
import { Steps } from "intro.js-react";
import { withRouter } from "react-router-dom";
import "intro.js/introjs.css";
import { setStep, setShowTutorial } from '../actions/user-actions';

import stepsWelcome from '../JSON/stepsWelcome'
import stepsCalendar from '../JSON/stepsCalendar'
import stepsSettings from '../JSON/stepsSettings'
import stepsTickers from '../JSON/stepsTickers'

class Tutorial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepsEnabled: this.props.showMeTutorial && this.props.isTutorial,
      initialStep: 0,
      steps: this.setSteps(this.props.type),
      hintsEnabled: true,
      moveSetting: false,
      showTutorial: true,
      stepIndex: 0,
      stepGlobal: this.setNumberSteps(this.props.type)
    };
  }

  setSteps = (type) => {
    switch (type) {
      case 'calendar':
        return this.props.isFirstTutorial ? stepsWelcome : stepsCalendar
      case 'settings':
        return stepsSettings 
      case 'tickers':
        return stepsTickers        
      default:
        return stepsCalendar
    }
  }

  setNumberSteps = (type) => {
    switch (type) {
      case 'calendar':
        this.props.setStep(9)
        return this.props.isFirstTutorial ? -2 : 9 
      case 'settings':
        this.props.setStep(0)
        return 0 
      case 'tickers':
        this.props.setStep(4)
        return 4   
      default:
          this.props.setStep(0)
          return 0
    }
  }


  onExit = () => {
    setTimeout(() => {
      this.props.setShowTutorial(false, false, false)
      this.setState({ stepsEnabled: false })
    },200)
  }

  onComplete = () => {
    const currentPath  = window.location.href;
    if ((currentPath.indexOf('/calendar') > -1 && this.state.steps.length === 6)) {
      this.setState({ stepsEnabled: false })
    } else {
      this.props.setShowTutorial(true, true, false)
      setTimeout(() => {
        if (currentPath.indexOf('/calendar') > -1) {
          this.props.history.push("/settings");
        } else if (currentPath.indexOf('/settings') > -1) {
          this.props.history.push("/tickers");
        } else if (currentPath.indexOf('/tickers') > -1) {
          this.props.history.push("/calendar");
        }
      },100)
    }
  }

  onBeforeChange = nextStepIndex => {

    if (this.state.stepIndex === nextStepIndex) {
      this.setState({
        stepGlobal: this.state.stepGlobal + 1
      })
    } else {
      if (this.state.stepIndex + 1 === nextStepIndex) {
        this.setState({
          stepGlobal: this.state.stepGlobal + 1,
          stepIndex: this.state.stepIndex + 1
        })
      }
      else if (this.state.stepIndex - 1 === nextStepIndex) {
        this.setState({
          stepGlobal: this.state.stepGlobal - 1,
          stepIndex: this.state.stepIndex - 1
        })
      }
      else if (this.state.stepIndex < nextStepIndex) {
        let dif = nextStepIndex - this.state.stepIndex
        this.setState({
          stepGlobal: this.state.stepGlobal + dif,
          stepIndex: this.state.stepIndex + dif
        })
      } else if (this.state.stepIndex > nextStepIndex) {
        let dif = this.state.stepIndex - nextStepIndex
        this.setState({
          stepGlobal: this.state.stepGlobal - dif,
          stepIndex: this.state.stepIndex - dif
        })
      }
    }
  }

  render() {
    const currentPath  = window.location.href;
    const { stepsEnabled, steps, initialStep, stepGlobal } = this.state;
    const showStepNumbers = steps.length > 2
    const text = (currentPath.indexOf('/calendar') > -1 && steps.length === 6)
      ? 'Done' : 'Next page'
    let time = (stepGlobal >= 6 && stepGlobal <= 9) || stepGlobal === 14
      ? 400 : 355
    
    // Change Step value
    setTimeout(() => {
      var el = document.querySelector(".introjs-helperNumberLayer");
        if(el) {
          el.innerHTML = stepGlobal
        }
      }, time)

    return (
      <>
        <Steps
          className={{}}
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          ref={steps => (this.steps = steps)}
          onBeforeChange={(step) => this.onBeforeChange(step)}
          options = {{
            doneLabel: text,
            showProgress: true,
            hideNext: true,
            hidePrev: true,
            showStepNumbers: showStepNumbers,
            disableInteraction: true,
            exitOnOverlayClick: false,
            stepNumberPosition: 'top-right'
          }}
          onExit={this.onExit}
          onComplete={this.onComplete}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stepTutorial: state.userReducer.stepTutorial,
    showMeTutorial: state.userReducer.showMeTutorial,
    isTutorial: state.userReducer.isTutorial,
    isFirstTutorial: state.userReducer.isFirstTutorial
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setStep: (step) => dispatch(setStep(step)),
    setShowTutorial: (show, isTutorial, isFirstTutorial) => dispatch(setShowTutorial(show, isTutorial, isFirstTutorial))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Tutorial))
